import React from "react";

const PARTNERS = [
  { src: "/icons/partners-logo/contredanse_vert.svg", alt: "Contredanse" },
  { src: "/icons/partners-logo/kunstenpunt_vert.svg", alt: "Kunstenpunt" },
  { src: "/icons/partners-logo/DCJ_vert.svg", alt: "Danscentrumjette" },
  { src: "/icons/partners-logo/RAC_vert.svg", alt: "RAC" },
  { src: "/icons/partners-logo/fwb_vert.svg", alt: "FWB" },
  { src: "/icons/partners-logo/VL_vert.svg", alt: "Vlaanderen" },
];

const ABOUT = {
  fr: [
    "Dance Map est une carte interactive réunissant plus de 870 adresses : compagnies, formations, lieux de ressources et d'accompagnement, financements, résidences et espaces de programmation. Elle centralise en un seul endroit les informations essentielles sur les acteur·rice·s du secteur et constitue une porte d'entrée pour toute personne qui cherche son chemin dans le milieu de la danse en Belgique.",
    "Le mode Information permet d'explorer le secteur actuel grâce à des fiches détaillées et des filtres par catégorie. Le mode Histoire propose une lecture évolutive en rendant visibles, au fil du temps, les apparitions et transformations des compagnies, lieux et festivals.",
    "Dance Map est une carte collaborative : les 870 adresses déjà référencées forment un point de départ et chacun·e peut contribuer à l'enrichir et à la mettre à jour.",
    "Dance Map est une initiative de CONTREDANSE en collaboration avec le DANSCENTRUMJETTE et KUNSTENPUNT grâce au soutien du programme CultuurCulture, développée en connexion avec le WELCOME PACK de la RAC.",
  ],
  en: [
    "Dance Map is an interactive map bringing together more than 870 addresses: companies, training programmes, resource and support centres, funding bodies, residencies and performance venues. It centralises essential information about the actors of the sector in one place and serves as a gateway for anyone seeking their way within the dance landscape in Belgium.",
    "The Information mode allows users to explore the current sector through detailed profiles and category filters. The History mode offers an evolving perspective by highlighting, over time, the emergence and transformation of companies, venues and festivals.",
    "Dance Map is a collaborative and evolving platform: the 870 addresses already referenced form a starting point, and everyone is invited to contribute by adding new entries or updating existing information.",
    "Dance Map is an initiative of CONTREDANSE, in collaboration with DANSCENTRUMJETTE and KUNSTENPUNT, with the support of the CultuurCulture programme, and developed in connection with the RAC's WELCOME PACK.",
  ],
  nl: [
    "Dance Map is een interactieve kaart met meer dan 870 adressen: gezelschappen, opleidingen, ondersteunings- en documentatiecentra, financieringsinstanties, residentieplekken en presentatieplekken. Ze bundelt essentiële informatie over de actoren van de sector op één plaats en vormt een toegangspoort voor iedereen die zijn weg zoekt binnen het Belgische danslandschap.",
    "De modus Informatie maakt het mogelijk de huidige sector te verkennen via gedetailleerde fiches en filters per categorie. De modus Geschiedenis biedt een evolutieve kijk door in de tijd de opkomst en veranderingen van gezelschappen, plekken en festivals zichtbaar te maken.",
    "Dance Map is een collaboratief en evolutief platform: de 870 reeds opgenomen adressen vormen een vertrekpunt en iedereen kan bijdragen door nieuwe vermeldingen toe te voegen of bestaande informatie te actualiseren.",
    "Dance Map is een initiatief van CONTREDANSE, in samenwerking met DANSCENTRUMJETTE en KUNSTENPUNT, met de steun van het CultuurCulture-programma, en ontwikkeld in verbinding met het WELCOME PACK van de RAC.",
  ],
};

const AboutPanel = ({ open, onClose, language = "fr" }) => {
  if (!open) return null;

  const paragraphs = ABOUT[language] || ABOUT.fr;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9,
        }}
      />
      {/* Panel */}
      <div
        style={{
          position: "fixed",
          top: window.innerWidth <= 768 ? 0 : "auto",
          bottom: window.innerWidth <= 768 ? 0 : 16,
          left: window.innerWidth <= 768 ? 0 : "auto",
          right: window.innerWidth <= 768 ? 0 : 16,
          width: window.innerWidth <= 768 ? "100%" : 420,
          maxHeight: window.innerWidth <= 768 ? "100vh" : "calc(100vh - 32px)",
          background: "rgba(255,255,255,0.98)",
          borderRadius: window.innerWidth <= 768 ? 0 : 8,
          boxShadow: "0 16px 48px rgba(0,0,0,0.22)",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pointerEvents: "auto",
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            border: "none",
            background: "transparent",
            color: "#265b4f",
            fontSize: 18,
            fontWeight: 700,
            cursor: "pointer",
            lineHeight: 1,
            padding: "4px 8px",
            zIndex: 1,
          }}
        >
          ✕
        </button>

        {/* Scrollable content */}
        <div
          className="sidebar-scroll"
          style={{
            flex: "1 1 auto",
            overflowY: "auto",
            padding: "20px 18px 16px 18px",
            scrollbarWidth: "thin",
            scrollbarColor: "#cbd5e0 transparent",
          }}
        >
          {paragraphs.map((para, i) => (
            <p
              key={i}
              style={{
                color: "#265b4f",
                fontSize: 15,
                lineHeight: 1.65,
                marginBottom: 18,
                marginTop: 0,
              }}
            >
              {para}
            </p>
          ))}
        </div>

        {/* Partner logos */}
        <div
          style={{
            flex: "0 0 auto",
            borderTop: "1px solid #e2e8f0",
            padding: "12px 18px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {PARTNERS.map((logo) => (
              <img
                key={logo.src}
                src={logo.src}
                alt={logo.alt}
                style={{ height: 36, objectFit: "contain", flex: "0 0 auto" }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPanel;
